export const recordedStatus = {
  ['initialize']: {
    name: 'initialize',
    title: '',
    description: '',
  },
  ['submitting']: {
    name: 'submitting',
    title: '🚀 Submitting 🚀',
    description: 'We are submitting your result',
  },
  'recorded-new': {
    name: 'recorded-new',
    title: '✅ Recorded ✅',
    description: 'Your reward has been successfully recorded.',
  },
  'recorded-leader': {
    name: 'recorded-leader',
    title: '🎉 Recorded - Representative 🎉',
    description:
      'Your team has been successfully recorded. You are chosen as the representative.',
  },
  'recorded-repeat': {
    name: 'recorded-repeat',
    title: '🟡 Waitlisted 🟡',
    description:
      'The reward has been claimed by someone else, so your entry is on the waitlist. The host will determine your eligibility.',
  },
  'failed-retry': {
    name: 'failed-retry',
    title: '❌ Not Available & Please Retry ❌',
    description:
      'This reward has just been claimed by another participant. Please spin again — the wheel has now been refreshed.',
  },
  'failed-gender-full': {
    name: 'failed-gender-full',
    title: '❌ Not Available & Gender Not Accepted ❌',
    description:
      'No teams are accepting your selected gender. Try another gender selection, or contact the host if this is an error.',
  },
  'failed-duplicate': {
    name: 'failed-duplicate',
    title: '❌ Failed - Duplicate Email ❌',
    description: 'Email already used. Only one submission allowed.',
  },
  'failed-max-submission': {
    name: 'failed-max-submission',
    title: '❌ Failed - Submission Limit Reached ❌',
    description: 'The maximum number of submissions has been reached.',
  },
  'failed-fully-joined': {
    name: 'failed-fully-joined',
    title: '❌ Failed - Teams Fully Joined ❌',
    description: 'All teams are already full. No teams are available to join.',
  },
  'failed-userinfo-error': {
    name: 'failed-userinfo-error',
    title: '❌ Failed ❌',
    description: 'User error',
  },
  'failed-resultdoc-error': {
    name: 'failed-resultdoc-error',
    title: '❌ Failed ❌',
    description: 'Database error',
  },
  'failed-error': {
    name: 'failed-error',
    title: '❌ Failed ❌',
    description: 'System error',
  },
}
